/** Selection du catalogue legal selon la langue affichee. */
import { FR } from './fr.js';
import { EN } from './en.js';
import type { LegalCatalog, LegalKind } from './types.js';

export type { LegalDocument, LegalKind, Section, Block } from './types.js';

export function legalCatalog(locale: string): LegalCatalog {
  return locale.startsWith('en') ? EN : FR;
}

export function legalDocument(locale: string, kind: LegalKind): LegalCatalog[LegalKind] {
  return legalCatalog(locale)[kind];
}
